import { Link } from 'react-router-dom';

import { buttonVariants } from '@/components/ui/button';
import { useAuthStore } from '@/stores/auth.store';

export function NotFoundPage() {
  // P1-Auth: tokens não vivem mais no store; presença do usuário reflete sessão local.
  const isLogged = !!useAuthStore((s) => s.usuario);
  const destino = isLogged ? '/dashboard' : '/login';
  const rotulo = isLogged ? 'Voltar ao dashboard' : 'Ir para o login';

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/40 px-4">
      <div className="space-y-4 text-center">
        <p className="text-5xl font-bold text-muted-foreground">404</p>
        <h1 className="text-2xl font-semibold">Página não encontrada</h1>
        <p className="text-sm text-muted-foreground">
          O endereço acessado não existe nesta aplicação.
        </p>
        <Link to={destino} className={buttonVariants({ variant: 'default' })}>
          {rotulo}
        </Link>
      </div>
    </div>
  );
}
